import Vue from 'vue';
// Transcript-specific store module
export class TranscriptStore {
    state = Vue.observable({
        transcripts: [],
        timedTranscripts: [],
        loading: false,
        error: null,
        autoScrollEnabled: true,
        userManuallyScrolled: false,
        pendingLinesBuffer: [],
        streamingActive: false,
        totalLines: 0,
        transcriptType: 'standard',
        superhostLines: [],
        speakers: []
    });
    // Getters
    get transcripts() {
        return this.state.transcripts;
    }
    get timedTranscripts() {
        return this.state.timedTranscripts;
    }
    get loading() {
        return this.state.loading;
    }
    get error() {
        return this.state.error;
    }
    get autoScrollEnabled() {
        return this.state.autoScrollEnabled;
    }
    get userManuallyScrolled() {
        return this.state.userManuallyScrolled;
    }
    get pendingLinesBuffer() {
        return this.state.pendingLinesBuffer;
    }
    get streamingActive() {
        return this.state.streamingActive;
    }
    get totalLines() {
        return this.state.totalLines;
    }
    get hasTranscripts() {
        return this.state.transcripts.length > 0;
    }
    get transcriptType() {
        return this.state.transcriptType;
    }
    get superhostLines() {
        return this.state.superhostLines;
    }
    get speakers() {
        return this.state.speakers;
    }
    get isSuperHostFormat() {
        return this.state.transcriptType === 'superhost';
    }
    // Actions
    setLoading(loading) {
        this.state.loading = loading;
    }
    setError(error) {
        this.state.error = error;
    }
    setTranscripts(transcripts) {
        this.state.transcripts = transcripts;
        this.state.totalLines = transcripts.length;
    }
    setTimedTranscripts(timedTranscripts) {
        this.state.timedTranscripts = timedTranscripts;
    }
    setTranscriptType(type) {
        this.state.transcriptType = type;
    }
    setSuperHostLines(lines) {
        this.state.superhostLines = lines;
        this.state.totalLines = lines.filter(line => line.type !== 'tooltip').length;
    }
    setSpeakers(speakers) {
        this.state.speakers = speakers;
    }
    addTranscript(transcript) {
        this.state.transcripts.push(transcript);
        this.state.totalLines = this.state.transcripts.length;
    }
    addTranscripts(transcripts) {
        this.state.transcripts.push(...transcripts);
        this.state.totalLines = this.state.transcripts.length;
    }
    // Scroll management
    setAutoScrollEnabled(enabled) {
        this.state.autoScrollEnabled = enabled;
    }
    setUserManuallyScrolled(scrolled) {
        this.state.userManuallyScrolled = scrolled;
    }
    // Buffer management
    addToPendingBuffer(line) {
        this.state.pendingLinesBuffer.push(line);
    }
    flushPendingBuffer() {
        if (this.state.pendingLinesBuffer.length > 0) {
            this.state.transcripts.push(...this.state.pendingLinesBuffer);
            this.state.pendingLinesBuffer = [];
            this.state.totalLines = this.state.transcripts.length;
        }
    }
    clearPendingBuffer() {
        this.state.pendingLinesBuffer = [];
    }
    // Streaming
    setStreamingActive(active) {
        this.state.streamingActive = active;
    }
    // Clear state
    clearTranscripts() {
        this.state.transcripts = [];
        this.state.timedTranscripts = [];
        this.state.pendingLinesBuffer = [];
        this.state.totalLines = 0;
        this.state.error = null;
    }
    clearAll() {
        this.state.transcripts = [];
        this.state.timedTranscripts = [];
        this.state.loading = false;
        this.state.error = null;
        this.state.autoScrollEnabled = true;
        this.state.userManuallyScrolled = false;
        this.state.pendingLinesBuffer = [];
        this.state.streamingActive = false;
        this.state.totalLines = 0;
    }
}
// Export singleton instance
export const transcriptStore = new TranscriptStore();
